import { useSyncExternalStore } from "react";

export type Store<T> = {
	getState: () => T;
	setState: (next: T | ((prev: T) => T)) => void;
	subscribe: (listener: () => void) => () => void;
};

export const createStore = <T>(initialState: T): Store<T> => {
	let state = initialState;
	const listeners = new Set<() => void>();

	return {
		getState: () => state,
		setState: (next) => {
			const nextState =
				typeof next === "function" ? (next as (prev: T) => T)(state) : next;
			if (Object.is(nextState, state)) {
				return;
			}
			state = nextState;
			//listeners.forEach((listener) => listener());
			for (const listener of listeners) {
				listener();
			}
		},
		subscribe: (listener) => {
			listeners.add(listener);
			return () => listeners.delete(listener);
		},
	};
};

export const useStore = <T>(store: Store<T>): T => {
	return useSyncExternalStore(store.subscribe, store.getState, store.getState);
};
